import RenderNested from "core/classes/RenderNested";
import StaffOptionsComponent from "../components/StaffOptions";

export default class StaffOptions extends RenderNested<null> {

  getComponent() {
    return StaffOptionsComponent;
  }
  
}